<div class="video-frame">
  <video
    src="assets/v2m.mp4"
    poster="assets/video_poster.jpg"
    controls
    autoplay
  ></video>
</div>
